const insurance = [{
  desc: '保单查询接口',
  options: {
    url: '/insurance/getInsuranceList',
    method: 'post'
  },
  vuex: false
}, {
  desc: '业务趋势图',
  options: {
    url: '/insurance/queryStatisticPriceAndIns',
    method: 'post'
  }
}, {
  desc: '添加保单号',
  options: {
    url: '/insurance/addInsuranceNum',
    method: 'post'
  }
}, {
  desc: '批量添加录单任务',
  options: {
    url: '/insurance/addInsuranceTask',
    method: 'post'
  }
}, {
  desc: '查询录单任务详情',
  options: {
    url: '/insurance/getInsuranceNums',
    method: 'post'
  }
}, {
  desc: '录单任务查询',
  options: {
    url: '/insurance/getInsuranceTask',
    method: 'post'
  }
}, {
  desc: '修改录单任务',
  options: {
    url: '/insurance/updateInsuranceTask',
    method: 'post'
  }
}, {
  desc: '查询录单任务工号配置',
  options: {
    url: '/insurance/queryInsuranceTaskConfig',
    method: 'post'
  }
}, {
  desc: '保存录单任务工号配置',
  options: {
    url: '/insurance/saveInsuranceTaskConfig',
    method: 'post'
  }
}, {
  desc: '查询未录入保单统计运行日志',
  options: {
    url: '/insurance/queryInsuranceTaskRunRecord',
    method: 'post'
  }
}, {
  desc: '动态保单查询',
  options: {
    url: '/insurance/insDynamicQuery',
    method: 'post'
  }
}, {
  desc: '保单删除',
  options: {
    url: '/insurance/deleteIns',
    method: 'post'
  }
}, {
  desc: '批量删除保单接口',
  options: {
    url: '/insurance/batchDeleteIns',
    method: 'post'
  }
}, {
  desc: '批量删除保单接口 继续',
  options: {
    url: '/insurance/batchDeleteInsForContinue',
    method: 'post'
  }
}, {
  desc: '单个保单或者本页勾选保单',
  options: {
    url: '/insurance/doesItIncludeFc',
    method: 'post'
  }
}, {
  desc: '全选保单查询',
  options: {
    url: '/insurance/insuranceQueryCheckAll',
    method: 'post'
  }
}, {
  desc: '保单数据',
  options: {
    url: '/insurance/insuranceFromIntf',
    method: 'get'
  }
}, {
  desc: '批量匹配政策任务列表',
  options: {
    url: '/export/getPolicyTasks',
    method: 'post'
  }
}, {
  desc: '批量匹配政策任务列表查看详情',
  options: {
    url: '/export/getPolicyTaskDetail',
    method: 'post'
  }
}, {
  desc: '人管组织机构车险业绩查询',
  options: {
    url: '/insurance/queryPerformanceList',
    method: 'post'
  }
}, {
  desc: '根据保单id保单的指定信息',
  options: {
    url: '/insurance/queryInsuranceAppointInfo',
    method: 'post'
  }
}, {
  desc: '根据保单号查询保单信息',
  options: {
    url: '/insurance/queryInsuranceByInsNo',
    method: 'get'
  }
}, {
  desc: '保单详情查询',
  options: {
    url: '/insurance/getInsuranceDetail',
    method: 'post'
  }
}, {
  desc: '批量录单-未录保单号查询',
  options: {
    url: '/insurance/queryInsurancenums',
    method: 'post'
  }
}, {
  desc: '批量录单-未录保单统计',
  options: {
    url: '/insurance/queryInsurancenumsStat',
    method: 'post'
  }
}, {
  desc: '批量录单-批量保单统计',
  options: {
    url: '/insurance/insurancenumsStateGroupQuery',
    method: 'post'
  }
}, {
  desc: '保单录入/编辑保存',
  options: {
    url: '/insurance/insuranceAddOrUpdate',
    method: 'post',
    needCustomMessage: true
  }
}, {
  desc: '手续费试算',
  options: {
    url: '/insurance/calcSettleInfo',
    method: 'post',
    formdata: true,
    needCustomMessage: true
  }
}, {
  desc: '关联单查询',
  options: {
    url: '/insurance/findRelationOrder',
    method: 'post'
  }
}, {
  desc: '批量录单-校验保单是否已存在',
  options: {
    url: '/insurance/checkInsurance',
    method: 'post',
    needCustomMessage: true
  }
}]
export default insurance



// WEBPACK FOOTER //
// ./src/api/insurance.js